// extracted by mini-css-extract-plugin
module.exports = {"productGift":"SubscriptionBonus_productGift__kQVYy","productGiftList":"SubscriptionBonus_productGiftList__BD67H"};